/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Combo_Duplicate_ComponentInputs */

const vi_error_combo_duplicate_component = /** @type {(inputs: Error_Combo_Duplicate_ComponentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một thành phần bị chọn hai lần. Gộp lại thành một dòng rồi lưu.`)
};

/**

* @param {Error_Combo_Duplicate_ComponentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_combo_duplicate_component = /** @type {((inputs?: Error_Combo_Duplicate_ComponentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Combo_Duplicate_ComponentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_combo_duplicate_component(inputs)
});